import * as React from "react";

const SvgDispatch = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.72 6.508c-.208.21-.477.316-.746.316a1.03 1.03 0 0 1-.745-.319 1.1 1.1 0 0 1 0-1.53l2.586-2.66c.21-.216.488-.32.766-.315.277-.006.555.1.765.316l2.592 2.66a1.1 1.1 0 0 1 0 1.53 1.04 1.04 0 0 1-1.49 0l-.824-.848v6.575H12.52V5.685zm.797 14.41V16.2h2.104v4.718c0 .598-.47 1.082-1.052 1.082s-1.052-.484-1.052-1.082m-4.91 0V16.2h2.105v4.718c0 .598-.47 1.082-1.052 1.082s-1.052-.484-1.052-1.082m11.5-10.248 2.586 2.66c.21.22.313.505.307.79.006.286-.097.571-.307.788l-2.58 2.653a1.04 1.04 0 0 1-1.49 0 1.1 1.1 0 0 1 0-1.53l.774-.796c-2.07 0-12.65 0-12.738-.006C3.607 15.121 2 13.381 2 11.27 2 9.08 3.73 7.3 5.857 7.3c3.118 0 3.858 2.801 3.858 4.989H7.61c0-.995-.138-2.825-1.754-2.825-.967 0-1.753.809-1.753 1.803 0 .956.719 1.74 1.64 1.8.563.003 10.894.003 12.723.003l-.848-.871c-.412-.42-.428-1.113 0-1.53.417-.405 1.076-.424 1.488 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDispatch;
